import { render, staticRenderFns } from "./Sponsorship.vue?vue&type=template&id=0afde0bc&"
import script from "./Sponsorship.vue?vue&type=script&lang=js&"
export * from "./Sponsorship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports